import PropTypes from 'prop-types'
import MenuFooter from './menu-footer'
import css from './menu.css'
import styled, { keyframes } from 'styled-components'
const menuIn = keyframes`
  0% {
      margin-bottom: -80px;
      opacity: 0;
      pointer-events: none;
      transform: translateY(-80px);
  }
  100% {
      margin-bottom: 6px;
      opacity: 1;
      pointer-events: none;
      transform: translateY(0);
  }
`

const MenuContainer = styled.div`
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 55px;
    left: 0;
    background: black;
`

const NewPill = styled.img`
    position: relative;
    top: 4px;
    left: 5px;
    display: inline-block;
`
const InnerContainer = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    animation: ${menuIn} 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
    font-size: 16px;
    margin: 6px -6px;
    padding-top: 8px;
    position: relative;
`
const MenuWrapper = styled.div`
    position: absolute;
    top: 0px;
    height: 100vh;
    left: 0;
    z-index: 9999;
    overflow: scroll;
    padding-bottom: 70px;
`
const Menu = ({ items, color }) => (
    <MenuContainer>
        <InnerContainer>
            <div className={css.niblet} style={{ color }} />
            <div className={css.backgroundWrapper}>
                <div className={css.background} style={{ backgroundColor: color }} />
            </div>
            <MenuWrapper>
                {items.map(({ header, items }, index) => (
                    <div className={css.item} key={index}>
                        {header.link ? (
                            <a className={css.title} href={header.link}>
                                {header.title} <i className={css.itemNiblet} />
                            </a>
                        ) : (
                            <span className={css.title}>{header.title}</span>
                        )}
                        <ul className={css.section}>
                            {items.map(({ title, link, newPill = false }, index) => (
                                <li key={index}>
                                    <a href={link}>{title}</a>
                                    {newPill && <NewPill src="/static/img/svg/pill-new.svg" alt="" />}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
                <MenuFooter />
            </MenuWrapper>
        </InnerContainer>
    </MenuContainer>
)

Menu.propTypes = {
    color: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
}

export default Menu
